import { getDateAndHour } from "./formatDate";

export const getOneYearDateRange = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const oneYearLater = new Date(today);
  oneYearLater.setFullYear(today.getFullYear() + 1);

  const startDate = today.toISOString().split(".")[0] + "Z";
  const endDate = oneYearLater.toISOString().split(".")[0] + "Z";

  return `[${startDate} TO ${endDate}]`;
};

export const getGoals = (match, team) => {
  if (match?.liveData?.matchDetails?.matchStatus === "Fixture") return;
  if (match?.liveData?.goal?.length === 0) return 0;
  const length = match?.liveData?.goal?.length;
  if (match?.liveData?.goal?.[length - 1]?.[team] >= 0) {
    return match?.liveData?.goal?.[length - 1]?.[team];
  }
  return 0;
};

export const isNewSeparatorDate = (match, prevMatch) => {
  if (!prevMatch) {
    return true;
  }
  const dateMatch = convertToLocalDate(
    `${match?.matchInfo?.date}T${match?.matchInfo?.time}`
  );
  const datePrevMatch = convertToLocalDate(
    `${prevMatch?.matchInfo?.date}T${prevMatch?.matchInfo?.time}`
  );
  dateMatch.setHours(0, 0, 0, 0);
  datePrevMatch.setHours(0, 0, 0, 0);
  if (dateMatch.getTime() > datePrevMatch.getTime()) {
    return true;
  }
  return false;
};

const getPeriod = (period, time) => {
  switch (period) {
    case 1:
      return `PT ${time ?? ""}`;
    case 2:
      return `ST ${time ?? ""}`;
    case 3:
      return `TE PT ${time ?? ""}`;
    case 4:
      return `TE ST ${time ?? ""}`;
    case 5:
      return "";
    case 10:
      return "ET";
    case 11:
      return "TE";
    case 12:
      return "ET TE";
    case 13:
      return "Penales";
    case 14:
      return "FIN";
    default:
      return "";
  }
};

export const getTimeMatch = (match) => {
  if (match?.liveData?.matchDetails?.matchStatus === "Playing") {
    return getPeriod(
      match?.liveData?.matchDetails?.periodId,
      match?.liveData?.matchDetails?.matchTime
    );
  }
  if (match?.liveData?.matchDetails?.matchStatus === "Postponed") {
    return "Post.";
  }
  if (match?.liveData?.matchDetails?.matchStatus === "Suspended") {
    return "Susp.";
  }
  if (match?.liveData?.matchDetails?.matchStatus === "Cancelled") {
    return "Canc.";
  }
  if (match?.liveData?.matchDetails?.matchStatus === "Played") {
    return "FIN";
  }
  if (match?.matchInfo?.time && match?.matchInfo?.date) {
    const dateObj = convertToLocalDate(
      `${match?.matchInfo?.date}T${match?.matchInfo?.time}`,
      match?.matchInfo?.id
    );
    const hours = dateObj.getHours().toString().padStart(2, "0");
    const minutes = dateObj.getMinutes().toString().padStart(2, "0");
    return `${hours}:${minutes}`;
  }
  return "A conf.";
};

export const getTimeMatchFormat = (match) => {
  if (match?.liveData?.matchDetails?.matchStatus === "Playing") {
    return "En vivo";
    /* return getPeriod(
      match?.liveData?.matchDetails?.periodId,
      match?.liveData?.matchDetails?.matchTime
    ); */
  }
  if (match?.liveData?.matchDetails?.matchStatus === "Postponed") {
    return "Postergado";
  }
  if (match?.liveData?.matchDetails?.matchStatus === "Suspended") {
    return "Suspendido";
  }
  if (match?.liveData?.matchDetails?.matchStatus === "Cancelled") {
    return "Cancelado";
  }
  if (match?.liveData?.matchDetails?.matchStatus === "Played") {
    return "Finalizado";
  }
  if (match?.matchInfo?.time && match?.matchInfo?.date) {
    const { date, time } = getLocalDateTime(match?.matchInfo?.date, match?.matchInfo?.time);
    return  `${date} ${time}`;
  }
  return "A conf.";
};

export const getMatchDateFormatted = (dateStr) => {
  const months = [
    "ENERO","FEBRERO","MARZO","ABRIL","MAYO","JUNIO",
    "JULIO","AGOSTO","SEPTIEMBRE","OCTUBRE","NOVIEMBRE","DICIEMBRE"
  ];

  if (!dateStr) return "";
  const [year, month, day] = dateStr?.split("-");

  return `${months[parseInt(month, 10) - 1]} ${parseInt(day, 10)}`;
}

export const getIconStatus = (status) => {
  const icons = {
    Fixture: `${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/mundial/calendar.svg`,
    Playing: `${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/mundial/circle-dot-regular-full.svg`,
    Postponed: `${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/mundial/calendar-xmark-solid-full.svg`,
    Suspended: `${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/mundial/calendar-xmark-solid-full.svg`,
    Cancelled: `${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/mundial/calendar-xmark-solid-full.svg`,
    Played: `${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/mundial/chart-simple-solid-full.svg`,
  }
  return icons[status] || `${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/mundial/bell-solid-full.svg`;
}

export const getDateTimeMatch = (match) => {
  let isPlaying = false;
  let description = "";
  let dateTime = "";
  if (match?.matchInfo?.localTime && match?.matchInfo?.localDate) {
    dateTime = getDateAndHour(
      match?.matchInfo?.localDate + " " + match?.matchInfo?.localTime
    );
  } else {
    description = "A conf.";
  }
  if (match?.liveData?.matchDetails?.matchStatus === "Playing") {
    isPlaying = true;
    description = getPeriod(
      match?.liveData?.matchDetails?.periodId,
      match?.liveData?.matchDetails?.matchTime
    );
  }
  if (match?.liveData?.matchDetails?.matchStatus === "Postponed") {
    description = "Postpuesto";
  }
  if (match?.liveData?.matchDetails?.matchStatus === "Suspended") {
    description = "Suspendido";
  }
  if (match?.liveData?.matchDetails?.matchStatus === "Cancelled") {
    description = "Cancelado";
  }
  if (match?.liveData?.matchDetails?.matchStatus === "Played") {
    description = "Finalizado";
  }
  return {
    isPlaying,
    description,
    dateTime,
  };
};

const convertToLocalDate = (dateString) => {
  const date = new Date(dateString.replaceAll("Z", ""));
  date.setHours(date.getHours() - 3);
  return date;
};

const getLocalDateTime = (dateUTC, timeUTC) => {
  if (!dateUTC || !timeUTC) return { date: '', time: '' };
  
  // Combinar fecha y hora UTC (dateUTC viene como "2026-06-11Z" y timeUTC como "19:00:00Z")
  // Remover la Z de la fecha y combinar con la hora
  const dateStr = dateUTC.replace('Z', '');
  const timeStr = timeUTC.replace('Z', '');
  const dateTimeString = `${dateStr}T${timeStr}Z`;
  
  const utcDate = new Date(dateTimeString);
  
  // Obtener mes y día en formato local
  const month = utcDate
    .toLocaleDateString('es-AR', { month: 'long' })
    .toUpperCase();
  const day = utcDate.toLocaleDateString('es-AR', { day: '2-digit' });
  
  const localDate = `${month} ${day}`;
  
  const localTime = utcDate.toLocaleTimeString('es-AR', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });
  
  return { date: localDate, time: localTime };
}

export const formatDateSeparator = (date, time) => {
  const options = { month: "short", day: "2-digit", weekday: "short" };
  const dateObj = convertToLocalDate(`${date}${time ? "T" + time : ""}`);
  const formattedDate = dateObj.toLocaleDateString("es-ES", options);  
  const [weekday, day, month] = formattedDate.split(" ");
  return (
    <>
      <span className="month">{month}</span>
      <span className="day">{day}</span>
      <span className="weekday">{weekday.replace(",", "")}</span>
    </>
  );
};

/**
 * Retorna un objeto con dos arreglos
 * primer arreglo con los partidos que sean mayor o igual a la fecha recibida
 * segundo arreglo con los partidos filtrados.
 * @param {string} date - string con la fecha en formato ISO (YYYY-MM-DD)
 * @param {Array} matches - Array de partidos
 * @return {Object} - Objeto con dos arreglos: partidos y partidosFiltrados
 *
 */
export const filterMatchesByDate = (date, matches) => {
  const dateObj = new Date(date);
  dateObj.setHours(0, 0, 0, 0);

  const nextMatches = [];
  const matchesFiltered = [];

  matches.forEach((match) => {
    if (match?.matchInfo?.localDate) {
      const matchDate = new Date(match.matchInfo.localDate);
      matchDate.setHours(0, 0, 0, 0);

      if (matchDate >= dateObj) {
        nextMatches.push(match);
      } else {
        matchesFiltered.push(match);
      }
    }
  });
  return { nextMatches, matchesFiltered };
};

/**
 * Retorno un arreglo con los eventos de un partido ordenado por periodo y tiempo. Recibe el detalle del partido.
 * @param {Object} match - Detalle del partido
 * @return {Array} - Arreglo de eventos ordenados por periodo y tiempo
 */
export const getEventsByMatch = (match) => {
  const cards = match?.liveData?.card ?? [];
  const goals = match?.liveData?.goal ?? [];
  const cardsAndGoals = [...cards, ...goals];
  return (
    match?.liveData?.matchDetails?.period
      ?.sort((a, b) => b.id - a.id)
      .map((period) => {
        const cardsAndGoalsFilter = cardsAndGoals.filter(
          (item) => item.periodId === period.id
        );
        const cardsAndGoalsHome = cardsAndGoalsFilter
          .filter(
            (item) =>
              (item.contestantId == match.matchInfo.contestant[0].id &&
                item.type !== "OG") ||
              (item.contestantId == match.matchInfo.contestant[1].id &&
                item.type === "OG")
          )
          .sort((a, b) => b.timeMin - a.timeMin);
        const cardsAndGoalsAway = cardsAndGoalsFilter
          .filter(
            (item) =>
              (item.contestantId == match.matchInfo.contestant[1].id &&
                item.type !== "OG") ||
              (item.contestantId == match.matchInfo.contestant[0].id &&
                item.type === "OG")
          )
          .sort((a, b) => b.timeMin - a.timeMin);

        const goalsHome = cardsAndGoalsHome.filter(
          (item) => item.type == "G" || item.type == "PG" || item.type == "OG"
        );
        const goalsHomeTotal = goalsHome.length;

        const goalsAway = cardsAndGoalsAway.filter(
          (item) => item.type == "G" || item.type == "PG" || item.type == "OG"
        );
        const goalsAwayTotal = goalsAway.length;

        return {
          ...period,
          cardsAndGoalsHome,
          goalsHomeTotal,
          cardsAndGoalsAway,
          goalsAwayTotal,
          description: period.id === 1 ? "1ER TIEMPO" : "2DO TIEMPO",
        };
      }) ?? []
  );
};

export const translateCard = (cardReason) => {
  switch (cardReason) {
    case "Foul":
      return "Falta";
    case "Excesive Celebration":
      return "Celebración excesiva";
    case "Argument":
      return "Discusión";
    case "Violent Conduct":
      return "Conducta violenta";
    case "Dissent":
      return "Disentimiento";
    case "Serious Foul":
      return "Falta grave";
    case "Time wasting":
      return "Pérdida de tiempo";
    default:
      return cardReason;
  }
};

export const eventPlayer = (idPlayer, liveData) => {
  if (!idPlayer || !liveData) {
    return [];
  }

  const events = [];

  liveData?.goal?.forEach((goal) => {
    if (goal.scorerId === idPlayer) {
      events.push({ type: "goal", timeMin: goal.timeMin });
    }
  });

  liveData?.card?.forEach((card) => {
    if (card.playerId === idPlayer) {
      const cardTypes = ["YC", "RC", "Y2C"];
      if (cardTypes.includes(card.type)) {
        events.push({ type: card.type, timeMin: card.timeMin });
      }
    }
  });

  liveData?.substitute?.forEach((sub) => {
    if (sub.playerOnId === idPlayer) {
      events.push({ type: "subsOn", timeMin: sub.timeMin });
    }
    if (sub.playerOffId === idPlayer) {
      events.push({ type: "subsOff", timeMin: sub.timeMin });
    }
  });

  return events.sort((a, b) => a.timeMin - b.timeMin);
};
